module.exports = __webpack_public_path__ + "static/media/selected.f4707590.svg";